import { inject } from "@angular/core";
import { type CanActivateFn } from "@angular/router";
import { EMPTY, catchError, map, switchMap } from "rxjs";
import { AuthService } from "../services/auth.service";

export const tokenGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);

  return authService.getRawToken().pipe(
    catchError(() => {
      authService.redirectToLoginSso();
      return EMPTY;
    }),
    switchMap((token) => {
      if (!token) {
        authService.redirectToLoginSso();
        return EMPTY;
      }
      return authService.isSantanderCnpAuthorized();
    }),
    map((isAuthorized) => {
      if (!isAuthorized) {
        authService.redirectToAccessDeniedSso();
      }
      return true;
    }),
  );
};
